export const SystemName = ''

export const MobileDeviceWidth = 768

export const NarrowDeviceWidth = 400

export const SidebarMaxWidth = 545

export const SidebarOffset = 150
